<template>
    <div class="df-inline-btn">
        <!-- TODO disable in preview mode -->
        <a class="btn btn-outline-secondary dfNavButton" target="_blank" :href="url">{{ settings.linkText || "Download form as a PDF" }}</a>
        <AdminSettingsDifferences :data="data" />
    </div>
</template>
<script lang="ts">
import { defineComponent, computed } from "vue";
import { props, Props, components, setup } from "./BaseDefMixin.3";
import type PdfAlternativeDef from "../elements/PdfAlternativeDef";
import type { PdfAlternativeSettings } from "@cs-ts/pdf-alternative-settings";
export default defineComponent({
    components: {
        ...components,
    },
    props: props,
    //@ts-ignore
    setup(props: Props<PdfAlternativeDef, PdfAlternativeSettings>) {
        const base = setup<PdfAlternativeDef, PdfAlternativeSettings>(props);

        const url = computed(() => {
            return props.data.fileUrl;
        });

        return {
            url,

            ...base.expose,
        };
    },
});
</script>
